import type { Theme } from '../../core/types';
import { drawChakra } from './draw-chakra';

export const narutoTheme: Theme = {
  id: 'naruto',
  name: 'Naruto',
  primaryAction: 'clone',
  primaryLabel: 'Naruto : créer des clones',
  pointerAction: 'dodge',
  greetings: [
    'Psst… clique sur moi.',
    'Prêt pour une nouvelle mission ?',
    'Je vais explorer par ici !',
    'On fait équipe, dattebayo ?',
    'Promis, je fais attention au décor.',
    'Une petite pause avant l’aventure.',
  ],
  character: {
    unitHeight: 340,
    projectileAnchors: {
      12: { x: 109, y: 1097 },
      13: { x: 464, y: 940 },
      14: { x: 952, y: 1038 },
    },
    frames: [
      [78, 0, 178, 330],
      [393, 0, 183, 330],
      [717, 0, 191, 332],
      [1031, 0, 186, 331],
      [24, 338, 291, 286],
      [387, 337, 234, 286],
      [643, 337, 300, 286],
      [1009, 337, 244, 286],
      [65, 708, 205, 229],
      [369, 626, 233, 254],
      [675, 624, 253, 275],
      [1009, 716, 244, 220],
      [49, 941, 244, 304],
      [356, 901, 245, 344],
      [687, 958, 293, 288],
      [1000, 1006, 240, 238],
    ],
  },
  summon: { columns: 2, rows: 2, baseline: 0.93 },
  atlases: {
    transformation: {
      unitHeight: 700,
      frames: [
        [0, 0, 543, 697],
        [543, 0, 543, 696],
        [1086, 0, 543, 696],
        [1629, 0, 543, 695],
      ],
      pivots: [
        { x: 280, y: 697 },
        { x: 302, y: 696 },
        { x: 307, y: 696 },
        { x: 326, y: 695 },
      ],
    },
    ramen: {
      unitHeight: 720,
      // Registered to each seated silhouette's center and shared foot baseline.
      frames: [
        [24, 60, 480, 592],
        [579, 60, 480, 592],
        [1128, 60, 480, 592],
        [1688, 60, 480, 592],
      ],
    },
  },
  messages: {
    clone: 'Kage Bunshin no Jutsu !',
    rasenshuriken: 'Fūton · Rasenshuriken !',
    summon: 'Kuchiyose no Jutsu !',
    jump: 'Toujours plus haut.',
    run: 'À fond, dattebayo !',
    kawarimi: 'Raté ! Kawarimi no Jutsu !',
    dodge: 'Même pas touché !',
    ramen: 'Une mission… après les ramen.',
    wallrun: 'La gravité ? Connais pas.',
    sexyjutsu: 'Oiroke no Jutsu !',
  },
  drawProjectile: drawChakra,
  assets: {
    character: 'character.webp',
    summon: 'summon.webp',
    ramen: 'ramen.webp',
    log: 'log.webp',
    transformation: 'transformation.webp',
  },
  clips: {
    idle: { frames: [0, 0, 0, 1], fps: 1.4, loop: true },
    run: { frames: [4, 5, 6, 7], fps: 12, loop: true },
    seal: { frames: [2, 3], fps: 5, loop: false },
    jump: { frames: [9, 10], fps: 5, loop: false },
    land: { frames: [11], fps: 1, loop: false },
    charge: { frames: [12, 13], fps: 2, loop: false },
    throw: { frames: [14], fps: 1, loop: false },
    summon: { frames: [15], fps: 1, loop: false },
    dodge: { frames: [9, 10], fps: 6, loop: false },
    ramen: { asset: 'ramen', frames: [0, 1, 2, 2, 3, 0], fps: 2.8, loop: true },
    wallrun: { frames: [4, 5, 6, 7], fps: 14, loop: true },
    transform: { asset: 'transformation', frames: [0, 1, 2, 2, 2, 3], fps: 2, loop: false },
  },
};
